import styles from "./Title.module.scss";
import localFont from "next/font/local";

interface Props {
  title: string;
  subtitle?: any;
  small?: boolean;
  noMarginTop?: boolean;
  noMarginBottom?: boolean;
}

export default function Title(props: Props) {
  const {
    title,
    subtitle,
    small = false,
    noMarginTop = false,
    noMarginBottom = false,
  } = props;

  return (
    <section
      className={small ? styles.title_smaller : styles.title}
      style={{
        marginTop: noMarginTop ? 0 : undefined,
        paddingTop: noMarginTop ? 0 : undefined,
        marginBottom: noMarginBottom ? 0 : undefined,
        paddingBottom: noMarginBottom ? 0 : undefined,
      }}
    >
      <h1
        style={{
          fontFamily: "var(--font-mirador)",
          fontWeight: 400,
          marginTop: noMarginTop ? 0 : undefined,
        }}
      >
        {title}
      </h1>
      {subtitle && <p>{subtitle}</p>}
    </section>
  );
}
